import React from 'react'

import { Button, ButtonClean, useMediaQueryContext } from '@fourthwall/components'
import { useCreateProduct } from '@modules/Dashboard/Product/hooks/useCreateProduct'
import { routing } from '@utils/routing'

import * as S from './CreateProductRecommendationContent.styled'
import { useFavoritesCountQuery } from './queries/useFavoritesCountQuery'

export const CreateProductRecommendationContent = () => {
  const { openCreateProductModal } = useCreateProduct()
  const media = useMediaQueryContext()
  const { favoritesCountQuery } = useFavoritesCountQuery()
  const count = favoritesCountQuery.data?.count || 0

  return (
    <S.Container>
      <Button
        label="Create a new product"
        fullWidth={!media.tablet}
        size="small"
        onClick={openCreateProductModal}
      />
      {count > 0 && (
        <ButtonClean
          appearance="secondary"
          label={`View favorites (${count})`}
          href={routing.productCatalog.favorites}
        />
      )}
    </S.Container>
  )
}
